module.exports = __webpack_public_path__ + "media/images/lb/167-f8e573775a3b38ffa291c3fee2a0c633.svg";